import { render } from "./LandingItems.vue?vue&type=template&id=e6e1d28a&scoped=true"
import script from "./LandingItems.vue?vue&type=script&lang=js"
export * from "./LandingItems.vue?vue&type=script&lang=js"

import "./LandingItems.vue?vue&type=style&index=0&id=e6e1d28a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e1d28a"]])

export default __exports__